import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initHeroAnim = () => {
  const tl = gsap.timeline();

  const body = document.querySelector("body");
  const nav = document.querySelector("nav");

  const heroSection = document.querySelector(".section__hero");
  const heroImg = document.querySelector(".section__hero--img");
  const heroOverlay = document.querySelector(".opacity-overlay");
  const heroTitle = document.querySelector(".section__hero--content h1");
  const heroSubtitle = document.querySelector(".section__hero--content p");
  const heroForm = document.querySelector(".section__hero--content form");

  if (heroSection) {
    tl.from(heroSection, {
      height: "100dvh",
      duration: 2,
      ease: "power4.inOut",
      clearProps: true,
    });

    tl.from(
      heroImg,
      {
        scale: 1.25,
        duration: 2,
        ease: "power4.inOut",
        clearProps: true,
      },
      "-=2",
    );

    tl.from(
      heroOverlay,
      {
        scale: 1.25,
        duration: 2,
        autoAlpha: 0,
        ease: "power4.inOut",
        clearProps: true,
      },
      "-=2",
    );

    tl.from(
      body,
      {
        duration: 2,
        paddingTop: 0,
        ease: "power4.inOut",
        clearProps: true,
      },
      "-=2",
    );

    tl.from(
      nav,
      {
        y: -100,
        duration: 2,
        ease: "power4.inOut",
        clearProps: true,
      },
      "-=2.1",
    );

    tl.from(heroTitle, {
      autoAlpha: 0,
      duration: 1,
    });

    tl.from(heroSubtitle, {
      autoAlpha: 0,
      duration: 1,
    });

    tl.from(
      heroForm,
      {
        autoAlpha: 0,
        duration: 1,
      },
      "-=1",
    );
  }
};

const initListingAnim = () => {
  const propertyListings = gsap.utils.toArray(".section__properties--listing");

  if (propertyListings.length < 0) {
    propertyListings.forEach((listing) => {
      gsap.from(listing, {
        scrollTrigger: {
          trigger: listing,
          start: "top 75%",
        },
        autoAlpha: 0,
        duration: 0.5,
        y: -50,
        ease: "circ",
      });
    });
  }
};

window.addEventListener("DOMContentLoaded", () => {
  const hasLoaded = sessionStorage.getItem("hasLoaded");

  if (!hasLoaded) {
    initHeroAnim();
    initListingAnim();

    sessionStorage.setItem("hasLoaded", true);
  }
});
